import { render, staticRenderFns } from "./KaiCheckbox.vue?vue&type=template&id=2024e424&scoped=true&"
import script from "./KaiCheckbox.vue?vue&type=script&lang=ts&"
export * from "./KaiCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./KaiCheckbox.vue?vue&type=style&index=0&id=2024e424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024e424",
  null
  
)

export default component.exports